import { Stack } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';
import { BottomButtons } from '../../BottomButtons';
import { CompletedDuration } from '../../CompletedDuration';
import { CreatedCompletedDatesRow } from '../../CreatedCompletedDatesRow';
import { HeaderTitle } from '../../HeaderTitle';
import { Status } from '../../Status';
import { HeaderMenu } from './HeaderMenu';
import { CloseButton } from '../../CloseButton';
import { SimulationGroup } from '@thive/fddm-types';
import { SimulationServiceFactory } from '@/modules/simulation/service/SimulationServiceFactory';

type Props = {
  simulationGroup: SimulationGroup;
  onEdit: (simulation: SimulationGroup) => void;
  onRerun: (simulation: SimulationGroup) => void;
  onClose: () => void;
};

export function Header({ simulationGroup, onEdit, onRerun, onClose }: Props) {
  const simSvc = useMemo(
    () => SimulationServiceFactory.getInstance().createSimulationService(),
    [],
  );

  const [isHover, setIsHover] = useState<boolean>();

  const onEditClicked = useCallback(() => {
    onEdit(simulationGroup);
  }, [onEdit, simulationGroup]);

  const onRerunClicked = useCallback(() => {
    onRerun(simulationGroup);
  }, [onRerun, simulationGroup]);

  const onAbortConfirm = useCallback(async () => {
    simSvc.abortSimulationGroup(simulationGroup.id);
  }, [simSvc, simulationGroup]);

  const onNameChanged = useCallback(
    (name: string) => {
      // PLZ FIX ME
      // eslint-disable-next-line react-hooks/immutability
      simulationGroup.name = name;
      simSvc.renameSimulationGroup(simulationGroup.id, name);
    },
    [simulationGroup, simSvc],
  );

  return (
    <Stack
      onMouseEnter={() => setIsHover(true)}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      sx={{ pb: 2, px: 2 }}
      gap={1}
    >
      <Stack direction='row' alignItems='center' justifyContent='space-between' gap={1}>
        <Status status={simulationGroup.status} isGroup sx={{ marginRight: 'auto' }} />
        {isHover && (
          <HeaderMenu
            simulation={simulationGroup}
            onEditClicked={onEditClicked}
            onRerunClicked={onRerunClicked}
          />
        )}
        <CloseButton onCloseClick={onClose} />
      </Stack>
      <Stack sx={{ gap: 1 }}>
        <HeaderTitle value={simulationGroup.name} onChange={onNameChanged} />
        <Stack sx={{ flexDirection: 'row', gap: 1, width: '100%' }}>
          <Stack sx={{ gap: 1, width: '100%' }}>
            {/* <VersionVehicleRow simulationGroup={simulationGroup} /> */}
            <CreatedCompletedDatesRow simulation={simulationGroup} />
            <CompletedDuration simulation={simulationGroup} />
          </Stack>
          {isHover && (
            <BottomButtons simulationGroup={simulationGroup} onAbortConfirm={onAbortConfirm} />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
